import styled from '@emotion/styled';
import { Theme } from './Btn.types';
import { variant, border, space, layout, fontSize, fontWeight } from 'styled-system';
import css from '@styled-system/css';

export const Btn = styled.button<any, Theme>`
  ${css({
    borderWidth: 2,
    borderStyle: 'solid',
    color: 'var(--color-extra-white)',
    outline: 'none',
    fontFamily: 'secondary',

    '&:hover': {
      cursor: 'pointer',
      boxShadow: '0 2px 2px rgba(58, 68, 81, 0.1)',
    },

    '&:focus': {
      borderColor: 'var(--color-lime)',
    },
    '&:hover:focus': {
      borderColor: 'var(--color-lime)',
    },
  })}

  ${space}
  ${layout}
  ${fontSize}
  ${fontWeight}
  ${border}
  ${variant({
    prop: 'mode',
    variants: {
      primary: {
        bg: 'var(--color-indigo)',
        borderColor: 'var(--color-indigo)',
        '&:hover': {
          bg: 'var(--color-indigo-t1)',
          borderColor: 'var(--color-indigo-t1)',
          color: 'var(--color-indigo)',
        },
        '&:hover:active': {
          bg: 'var(--color-indigo-t11)',
          borderColor: 'var(--color-indigo-t11)',
          color: 'var(--color-extra-white)',
        },
        '&:disabled': {
          bg: 'var(--color-indigo-t1)',
          borderColor: 'var(--color-indigo-t1)',
        },
      },
      secondary: {
        bg: 'var(--color-vibrant-blue-t8)',
        borderColor: 'var(--color-vibrant-blue-t8)',
        '&:hover:not(:disabled)': {
          bg: 'var(--color-vibrant-blue-t7)',
          borderColor: 'var(--color-vibrant-blue-t7)',
        },
        '&:hover:active': {
          bg: 'var(--color-indigo-t11)',
          borderColor: 'var(--color-indigo-t11)',
        },
        '&:disabled': {
          bg: 'var(--color-vibrant-blue-t10)',
          borderColor: 'var(--color-vibrant-blue-t10)',
          opacity: '30%',
        },
      },
      normal: {
        bg: 'var(--color-extra-white)',
        color: 'var(--color-indigo-t6)',
        borderColor: 'var(--color-indigo-t3)',
        '&:hover': {
          bg: 'var(--color-indigo-t1)',
          borderColor: 'var(--color-indigo)',
          color: 'var(--color-indigo-t11)',
        },
        '&:hover:active': {
          bg: 'var(--color-indigo-t0)',
          borderColor: 'var(--color-indigo-t11)',
        },
        '&:disabled': {
          color: 'var(--color-indigo-t4)',
          bg: 'var(--color-b0)',
          borderColor: 'var(--color-indigo-t1)',
        },
      },
      ghost: {
        bg: 'var(--color-extra-white)',
        color: 'var(--color-indigo-t6)',
        borderColor: 'var(--color-indigo-t3)',
        '&:hover': {
          bg: 'var(--color-extra-white)',
          borderColor: 'var(--color-indigo)',
          color: 'var(--color-indigo-t11)',
        },
        '&:hover:active': {
          bg: 'var(--color-extra-white)',
          borderColor: 'var(--color-indigo-t11)',
        },
        '&:disabled': {
          color: 'var(--color-indigo-t4)',
          bg: 'var(--color-b0)',
          borderColor: 'var(--color-indigo-t4)',
        },
      },
      success: {
        bg: 'var(--color-extra-white)',
        borderColor: 'var(--color-vibrant-blue-t9)',
        color: 'var(--color-vibrant-blue-t9)',
        '&:focus': {
          borderColor: 'var(--color-vibrant-blue-t9)',
          boxShadow: '0px 0px 1px 1px var(--color-lime)',
        },
        '&:hover:focus': {
          borderColor: 'var(--color-vibrant-blue-t9)',
          boxShadow: '0px 0px 1px 1px var(--color-lime)',
        },
        '&:hover:not(:disabled)': {
          borderColor: 'var(--color-vibrant-blue-t4)',
          color: 'var(--color-vibrant-blue-t4)',
        },
        '&:hover:active': {
          borderColor: 'var(--color-vibrant-blue-t11)',
          color: 'var(--color-vibrant-blue-t9)',
          boxShadow: 'none',
        },
        '&:disabled': {
          bg: 'var(--color-b0)',
          borderColor: 'var(--color-indigo-t4)',
          color: 'var(--color-indigo-t4)',
        },
      },
      warning: {
        bg: 'var(--color-extra-white)',
        borderColor: 'var(--color-lime-t8)',
        color: 'var(--color-lime-t8)',
        '&:focus': {
          borderColor: 'var(--color-lime-t8)',
          boxShadow: '0px 0px 1px 1px var(--color-lime)',
        },
        '&:hover:focus': {
          borderColor: 'var(--color-lime-t8)',
          boxShadow: '0px 0px 1px 1px var(--color-lime)',
        },
        '&:hover:not(:disabled)': {
          borderColor: 'var(--color-lime-t4)',
          color: 'var(--color-lime-t4)',
        },
        '&:hover:active': {
          borderColor: 'var(--color-lime-t11)',
          color: 'var(--color-lime-t8)',
          boxShadow: 'none',
        },
        '&:disabled': {
          bg: 'var(--color-b0)',
          borderColor: 'var(--color-indigo-t4)',
          color: 'var(--color-indigo-t4)',
        },
      },
      error: {
        '&:focus': {
          borderColor: 'var(--color-coral)',
          boxShadow: '0px 0px 1px 1px var(--color-lime)',
        },
        '&:hover:focus': {
          borderColor: 'var(--color-coral)',
          boxShadow: '0px 0px 1px 1px var(--color-lime)',
        },
        bg: 'var(--color-extra-white)',
        borderColor: 'var(--color-coral)',
        color: 'var(--color-coral)',
        '&:hover:not(:disabled)': {
          borderColor: 'var(--color-coral-t4)',
          color: 'var(--color-coral-t4)',
        },
        '&:hover:active': {
          borderColor: 'var(--color-coral-t9)',
          color: 'var(--color-coral)',
          boxShadow: 'none',
        },
        '&:disabled': {
          bg: 'var(--color-b0)',
          borderColor: 'var(--color-indigo-t4)',
          color: 'var(--color-indigo-t4)',
        },
      },
      loading: {
        '&:focus': {
          borderColor: 'var(--color-indigo-t3)',
          boxShadow: '0px 0px 1px 1px var(--color-lime)',
        },
        '&:hover:focus': {
          borderColor: 'var(--color-indigo-t3)',
          boxShadow: '0px 0px 1px 1px var(--color-lime)',
        },
        bg: 'var(--color-extra-white)',
        color: 'var(--color-indigo-t11)',
        borderColor: 'var(--color-indigo-t3)',
        '&:hover:not(:disabled)': {
          borderColor: 'var(--color-indigo-t3)',
          color: 'var(--color-indigo-t5)',
        },
        '&:hover:active': {
          borderColor: 'var(--color-indigo-t11)',
          color: 'var(--color-indigo-t11)',
          boxShadow: 'none',
        },
        '&:disabled': {
          bg: 'var(--color-b0)',
          borderColor: 'var(--color-indigo-t4)',
          color: 'var(--color-indigo-t4)',
        },
      },
    },
  })}

  ${css({
    ':disabled': {
      pointerEvents: 'none',
    },
  })}
`;

export default Btn;
